import React, { useEffect, useRef } from 'react'
// import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Link } from 'react-router-dom';
import { useModal } from '../../contexts/ModalContext';
import Slider from "react-slick";

export default function LandingGallery() {
    const sliderRef = useRef(null);
    const { openQueryModal } = useModal();

    // useEffect(() => {
    //     Fancybox.bind("[data-fancybox='gallery']", {});
    //     return () => Fancybox.destroy();
    // }, []);

    useEffect(() => {
  let fb;

  if (typeof window !== "undefined") {
    import("@fancyapps/ui").then((mod) => {
      fb = mod.Fancybox;
      fb.bind("[data-fancybox='gallery']", {});
    });
  }

  return () => {
    if (fb) {
      fb.destroy();
    }
  };
}, []);


    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 4,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
        responsive: [
            {
            breakpoint: 991,
            settings: { slidesToShow: 2, },
            },
            {
                breakpoint: 767,
                settings: { slidesToShow: 2,},
            },
            {
                breakpoint: 599,
                settings: { slidesToShow: 1,},
            },
        ],
    };

    const CustomArrows = () => (
        <>
        <div className="default-arrow default-mobilearrow" onClick={() => sliderRef.current.slickPrev()}>
            <i className="fa-solid fa-arrow-left"></i>
        </div>
        <div className="default-arrow default-mobilearrow default-arrowright" onClick={() => sliderRef.current.slickNext()}>
            <i className="fa-solid fa-arrow-right"></i>
        </div>
        </>
    );


    const galleryData = [
        "/assets/images/land-gallery-1.webp",
        "/assets/images/land-gallery-2.webp",
        "/assets/images/land-gallery-3.webp",
        "/assets/images/land-gallery-4.webp",
        "/assets/images/land-gallery-5.webp",
        "/assets/images/land-gallery-6.webp",
        "/assets/images/land-gallery-7.webp",
        "/assets/images/land-gallery-8.webp",
        "/assets/images/land-gallery-9.webp",
        "/assets/images/land-gallery-10.webp",
        "/assets/images/land-gallery-11.webp",
        "/assets/images/land-gallery-12.webp",
        "/assets/images/land-gallery-13.webp",
        "/assets/images/land-gallery-14.webp",

        "/assets/images/land-gallery-15.webp",
        "/assets/images/land-gallery-16.webp",
        "/assets/images/land-gallery-17.webp",
        "/assets/images/land-gallery-18.webp",
        "/assets/images/land-gallery-19.webp",
        "/assets/images/land-gallery-20.webp",
        "/assets/images/land-gallery-21.webp",
        "/assets/images/land-gallery-22.webp",
        "/assets/images/land-gallery-23.webp",
    ];

  return (
    <>
    <section className="landpage-gallery">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <h4 className='heading center-heading'>Work Showcase Gallery</h4>
                </div>

                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-1.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-1.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-2.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-2.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-4 col-md-4">
                    <a href="/assets/images/land-gallery-3.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-3.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-4 col-md-4">
                    <a href="/assets/images/land-gallery-4.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-4.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-4 col-md-4">
                    <a href="/assets/images/land-gallery-5.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-5.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-6.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-6.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-7.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-7.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>


                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-8.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-8.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-9.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-9.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-4 col-md-4">
                    <a href="/assets/images/land-gallery-10.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-10.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-4 col-md-4">
                    <a href="/assets/images/land-gallery-11.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-11.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-4 col-md-4">
                    <a href="/assets/images/land-gallery-12.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-12.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-13.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-13.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-14.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-14.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>


                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-15.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-15.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-16.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-16.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-4 col-md-4">
                    <a href="/assets/images/land-gallery-17.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-17.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-4 col-md-4">
                    <a href="/assets/images/land-gallery-18.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-18.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-4 col-md-4">
                    <a href="/assets/images/land-gallery-19.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-19.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-20.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-20.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-21.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-21.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-22.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-22.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className="col-lg-6 col-md-6">
                    <a href="/assets/images/land-gallery-23.webp" data-fancybox="gallery" className="landgallery-box">
                        <img src="/assets/images/land-gallery-23.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <i className="fa-solid fa-expand"></i>
                    </a>
                </div>

                <div className='col-lg-12 landgallery-slider'>
                    <div className='p-relative'>
                        <Slider {...settings} ref={sliderRef}>
                            {galleryData.map((img, index) => (
                                <a href={img} data-fancybox="gallery" className="landgallery-box" key={index}>
                                    <img src={img} className="img-responsive" alt="gallery" loading="lazy" />
                                    <i className="fa-solid fa-expand"></i>
                                </a>
                            ))}
                        </Slider>
                        <CustomArrows />
                    </div>
                </div>

                <div className='col-lg-12 text-center'>
                    <Link onClick={openQueryModal} className="default-butn">
                        <span className="text">Consult Now</span>
                        <div className="icon-container">
                            <div className="icon icon--left">
                                <i className="fa-solid fa-arrow-right"></i>
                            </div>
                            <div className="icon icon--right">
                                <i className="fa-solid fa-arrow-right"></i>
                            </div>
                        </div>
                    </Link>
                </div>
               
            </div>
        </div>
    </section>  
    </>
  )
}
